/**
 * Dữ liệu MẪU cho 3 loại bài tập LISTENING_CHOICE / MATCH_PAIRS / TRUE_FALSE.
 *
 * 1. Vì sao tồn tại: seed giáo trình (packages/database/prisma/seed/parsers/exercises.ts) chỉ sinh
 *    được CLOZE / MULTIPLE_CHOICE / TAP_TO_BUILD, nên DB hiện có 0 bản ghi của 3 loại này và API
 *    thật sẽ KHÔNG BAO GIỜ trả về chúng. UI dựng sẵn để khi content có thật chỉ cần đổi nguồn dữ liệu.
 * 2. Đây KHÔNG phải bug: người dùng thật không gặp 3 nhánh này qua màn Luyện tập.
 * 3. Nội dung tiếng Nhật chỉ ở mức Minna Bài 1; phần phán xét đúng/sai là BẢN DỊCH TIẾNG VIỆT,
 *    không phải tính đúng/sai của ngữ pháp Nhật — tránh dạy sai ngữ pháp bằng dữ liệu mẫu.
 */

export interface ListeningChoiceFixture {
  question: string;
  transcriptJp: string;
  transcriptVi: string;
  options: string[];
  correctIndex: number;
}

export interface MatchPairFixture {
  id: string;
  jp: string;
  vi: string;
}

export interface MatchPairsFixture {
  pairs: MatchPairFixture[];
  /** Thứ tự id ở cột nghĩa (phải khác thứ tự `pairs`) — cố định, KHÔNG shuffle. */
  rightOrder: string[];
}

export interface TrueFalseFixture {
  order: number;
  statementJp: string;
  claimVi: string;
  /** true = bản dịch khớp câu Nhật. */
  isTrue: boolean;
  explainVi: string;
}

export const mockListeningChoice: ListeningChoiceFixture = {
  question: 'Người nói giới thiệu mình là gì?',
  transcriptJp: 'わたしは がくせいです。',
  transcriptVi: 'Tôi là học sinh.',
  options: ['Học sinh', 'Giáo viên', 'Người Nhật'],
  correctIndex: 0,
};

export const mockMatchPairs: MatchPairsFixture = {
  pairs: [
    { id: 'p1', jp: 'わたし', vi: 'tôi' },
    { id: 'p2', jp: 'がくせい', vi: 'học sinh' },
    { id: 'p3', jp: 'せんせい', vi: 'giáo viên' },
    { id: 'p4', jp: 'にほん', vi: 'Nhật Bản' },
  ],
  rightOrder: ['p3', 'p1', 'p4', 'p2'],
};

export const mockTrueFalse: TrueFalseFixture[] = [
  { order: 1, statementJp: 'わたしは がくせいです。', claimVi: 'Tôi là học sinh.', isTrue: true,
    explainVi: 'は đánh dấu chủ đề, です tương đương "là".' },
  { order: 2, statementJp: 'あの人は せんせいです。', claimVi: 'Người kia là học sinh.', isTrue: false,
    explainVi: 'せんせい nghĩa là giáo viên, không phải học sinh.' },
  { order: 3, statementJp: '山田さんは にほんじんです。', claimVi: 'Anh Yamada là người Nhật.', isTrue: true,
    explainVi: 'にほんじん = người Nhật.' },
];
